export const whatBalanceTransferData = [
  {
    id: 1,
    heading: "What Is a Balance Transfer, and Should You Do One in India?",
    subHeading:
      "A balance transfer can help you save money by moving your debt from a high-interest credit card or loan to one with a lower interest rate. This guide simplifies the concept for Indian borrowers and helps you decide if a balance transfer is the right option for you.",
    notice:
      "Many or all of the products on this page are from partners who compensate us when you click to or take an action on their website, but this does not influence our evaluations or ratings. Our opinions are our own.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];

export const refinancingCarLoanData = [
  {
    id: "step-one",
    stepName: "What is a balance transfer? ",
  },
  {
    id: "step-two",
    stepName: "Who should do a balance transfer? ",
  },
  {
    id: "step-three",
    stepName: "Who Can Do a Balance Transfer in India? ",
  },
  {
    id: "step-four",
    stepName: "How to Do a Balance Transfer in India",
  },
  {
    id: "step-five",
    stepName: "How much can you save with a balance transfer? ",
  },

  {
    id: "step-six",
    stepName: "When Not to Do a Balance Transfer",
  },
  {
    id: "step-seven",
    stepName: "How to Choose the Best Balance Transfer Option in India ",
  },
];
